export const ru = {
    'pay-not-allowed-cpm':
        'Для оплаты медийных кампаний необходимо выставить отдельный счет. Оплата вместе с другими кампаниями недоступна.',
    'pay-not-allowed-deals':
        'Для оплаты кампаний со сделками необходимо выставить отдельный счет. Оплата вместе с кампаниями без сделок недоступна.',
    'pay-will-not-apply-for-campaigns':
        'Выбранное действие недоступно для кампаний: {campaignsIds}'
};
